/* ============================================================
   Cupido's Drops — cart drawer logic
   add-to-cart interception · drawer render from /cart.js
   package protection toggle · quantity steppers
   ============================================================ */
(function () {
  'use strict';

  var cfg = window.cupidoCartConfig || {};
  var PROTECTION_ID = cfg.protectionVariantId || 46027506221247;
  var CURRENCY = cfg.currency || 'USD';
  var COMPARE_AT = cfg.compareAt || {};
  var PROTECTION_PRICE = typeof cfg.protectionPrice === 'number' ? cfg.protectionPrice : 700;

  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  if (!drawer || !overlay) return;

  var closeBtn = drawer.querySelector('[data-cart-close]');
  var itemsWrap = drawer.querySelector('[data-cart-items]');
  var emptyState = drawer.querySelector('[data-cart-empty]');
  var summary = drawer.querySelector('[data-cart-summary]');
  var savingsRow = drawer.querySelector('[data-cart-savings-row]');
  var savingsEl = drawer.querySelector('[data-cart-savings]');
  var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
  var countEl = drawer.querySelector('[data-cart-count]');
  var protectionBox = drawer.querySelector('[data-cart-protection]');
  var protectionStatus = drawer.querySelector('[data-protection-status]');
  var protectionToggle = drawer.querySelector('[data-protection-toggle]');
  var protectionCard = drawer.querySelector('[data-protection-card]');
  var protectionPriceEl = drawer.querySelector('[data-protection-price]');
  var protectionCardPrice = drawer.querySelector('[data-protection-card-price]');
  var trustList = drawer.querySelector('[data-cart-trust]');
  var foot = drawer.querySelector('[data-cart-foot]');
  var checkoutBtn = drawer.querySelector('[data-cart-checkout]');
  var coverageBtn = drawer.querySelector('[data-cart-coverage]');

  var lastFocus = null;
  var isOpen = false;

  /* ---------- Helpers ---------- */
  function money(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: CURRENCY });
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function isProtection(item) {
    return item.variant_id === PROTECTION_ID || item.handle === 'shipping-protection';
  }

  function imgUrl(item) {
    var url = item.image || (item.featured_image && item.featured_image.url) || '';
    if (url && url.indexOf('http') !== 0) url = 'https:' + url;
    if (url) url += (url.indexOf('?') === -1 ? '?' : '&') + 'width=160';
    return url;
  }

  /* ---------- "✓ Added" button feedback (1.5s) ---------- */
  function flashAdded(btn) {
    if (!btn) return;
    if (btn.dataset.cartOrig === undefined) {
      btn.dataset.cartOrig = btn.innerHTML;
    }
    btn.classList.add('is-added');
    btn.disabled = true;
    btn.textContent = '✓ Added';
    setTimeout(function () {
      btn.innerHTML = btn.dataset.cartOrig;
      btn.classList.remove('is-added');
      btn.disabled = false;
    }, 1500);
  }

  /* ---------- Render ---------- */
  function render(cart) {
    var count = cart.item_count;

    /* Header badge (site header) */
    document.querySelectorAll('[data-cart-badge]').forEach(function (badge) {
      badge.textContent = count;
      badge.hidden = count === 0;
    });

    /* Drawer title */
    if (countEl) {
      countEl.textContent = '• ' + count + (count === 1 ? ' item' : ' items');
    }

    var hasItems = count > 0;
    if (emptyState) emptyState.hidden = hasItems;
    if (summary) summary.hidden = !hasItems;
    if (protectionBox) protectionBox.hidden = !hasItems;
    if (trustList) trustList.hidden = !hasItems;
    if (foot) foot.hidden = !hasItems;

    if (!hasItems) {
      if (itemsWrap) itemsWrap.innerHTML = '';
      return;
    }

    /* Items */
    var totalSavings = 0;
    var html = '';
    cart.items.forEach(function (item) {
      var protection = isProtection(item);
      var compareRef = Math.max(item.original_price, COMPARE_AT[item.variant_id] || 0);
      var hasSave = compareRef > item.final_price;
      if (hasSave) {
        totalSavings += (compareRef - item.final_price) * item.quantity;
      }

      html += '<div class="cb-cart__item" data-line="' + esc(item.key) + '">';

      if (protection) {
        html +=
          '<span class="cb-cart__item-shield">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3 19 5.5v5c0 4.7-3 8.6-7 10-4-1.4-7-5.3-7-10v-5l7-2.5Z"/><path d="m9 11.8 2.1 2.1L15.2 9.5"/></svg>' +
          '</span>';
      } else {
        html += '<img class="cb-cart__item-thumb" src="' + esc(imgUrl(item)) + '" width="72" height="72" alt="" loading="lazy">';
      }

      html += '<div class="cb-cart__item-body">';
      html += '<p class="cb-cart__item-title">' + esc(item.product_title) + '</p>';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        html += '<p class="cb-cart__item-variant">' + esc(item.variant_title) + '</p>';
      }

      html += '<div class="cb-cart__item-row">';
      if (!protection) {
        html +=
          '<span class="cb-cart__stepper">' +
          '<button type="button" data-cart-dec="' + esc(item.key) + '" data-qty="' + item.quantity + '" aria-label="Decrease quantity">−</button>' +
          '<span class="cb-cart__stepper-qty" aria-live="polite">' + item.quantity + '</span>' +
          '<button type="button" data-cart-inc="' + esc(item.key) + '" data-qty="' + item.quantity + '" aria-label="Increase quantity">+</button>' +
          '</span>';
      }

      html += '<span class="cb-cart__item-prices">';
      if (hasSave) {
        html += '<s class="cb-cart__item-compare">' + money(compareRef * item.quantity) + '</s>';
      }
      html += '<span class="cb-cart__item-price">' + money(item.final_line_price) + '</span>';
      if (hasSave) {
        html += '<span class="cb-cart__item-save">(You save ' + money((compareRef - item.final_price) * item.quantity) + ')</span>';
      }
      html += '</span>'; /* prices */
      html += '</div>'; /* row */
      html += '</div>'; /* body */

      if (!protection) {
        html +=
          '<button class="cb-cart__item-remove" type="button" data-cart-remove="' + esc(item.key) + '" aria-label="Remove ' + esc(item.product_title) + '">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16"/><path d="M9 7V5.5A1.5 1.5 0 0 1 10.5 4h3A1.5 1.5 0 0 1 15 5.5V7"/><path d="M6.5 7l.8 12a1.6 1.6 0 0 0 1.6 1.5h6.2a1.6 1.6 0 0 0 1.6-1.5l.8-12"/><path d="M10 11v6M14 11v6"/></svg>' +
          '</button>';
      }

      html += '</div>'; /* item */
    });

    if (itemsWrap) itemsWrap.innerHTML = html;

    /* Cart-level discounts count toward savings */
    (cart.cart_level_discount_applications || []).forEach(function (discount) {
      totalSavings += discount.total_allocated_amount || 0;
    });

    /* Summary */
    if (savingsRow && savingsEl) {
      savingsRow.hidden = totalSavings <= 0;
      savingsEl.textContent = '−' + money(totalSavings);
    }
    if (subtotalEl) {
      subtotalEl.textContent = money(cart.total_price);
    }

    /* Protection box */
    var protectionItem = null;
    cart.items.forEach(function (item) {
      if (isProtection(item)) protectionItem = item;
    });
    var isProtected = !!protectionItem;

    if (protectionStatus) {
      protectionStatus.textContent = isProtected ? 'Your order is protected.' : "Your order isn't protected.";
    }
    if (protectionToggle) {
      protectionToggle.setAttribute('aria-checked', isProtected ? 'true' : 'false');
    }
    if (protectionPriceEl) {
      protectionPriceEl.hidden = !isProtected;
      protectionPriceEl.textContent = money(isProtected ? protectionItem.final_line_price : PROTECTION_PRICE);
    }
    if (protectionCard) {
      protectionCard.hidden = isProtected;
    }
    if (protectionCardPrice) {
      protectionCardPrice.textContent = money(PROTECTION_PRICE);
    }
    if (coverageBtn) {
      coverageBtn.textContent = isProtected ? 'Continue without coverage' : 'Re-add protection';
    }
  }

  /* ---------- Cart API ---------- */
  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        render(cart);
        return cart;
      });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('change failed');
        return res.json();
      })
      .then(function (cart) {
        render(cart);
        return cart;
      });
  }

  function addProtection() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: PROTECTION_ID, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        return refresh();
      });
  }

  function removeProtection() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var found = null;
        cart.items.forEach(function (item) {
          if (isProtection(item)) found = item;
        });
        if (!found) return cart;
        return changeLine(found.key, 0);
      });
  }

  function toggleProtection() {
    if (!protectionToggle) return;
    var turnOn = protectionToggle.getAttribute('aria-checked') !== 'true';
    protectionToggle.disabled = true;
    if (coverageBtn) coverageBtn.disabled = true;
    var req = turnOn ? addProtection() : removeProtection();
    req.finally(function () {
      protectionToggle.disabled = false;
      if (coverageBtn) coverageBtn.disabled = false;
    });
  }

  /* ---------- Open / close ---------- */
  function onKeydown(event) {
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    /* Basic focus trap */
    var focusable = drawer.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
    var visible = [];
    focusable.forEach(function (el) {
      if (el.offsetParent !== null || el === document.activeElement) visible.push(el);
    });
    if (!visible.length) return;
    var first = visible[0];
    var last = visible[visible.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function open() {
    if (isOpen) return;
    isOpen = true;
    lastFocus = document.activeElement;
    overlay.hidden = false;
    window.requestAnimationFrame(function () {
      overlay.classList.add('is-open');
    });
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cb-cart-locked');
    document.addEventListener('keydown', onKeydown);
    if (closeBtn) closeBtn.focus();
    refresh();
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cb-cart-locked');
    document.removeEventListener('keydown', onKeydown);
    setTimeout(function () {
      if (!isOpen) overlay.hidden = true;
    }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- Global add-to-cart interception ---------- */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.tagName || form.tagName !== 'FORM') return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;

      event.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      flashAdded(submitBtn);

      var fd = new FormData(form);
      var id = Number(fd.get('id'));
      if (!id) return;
      var item = { id: id, quantity: Number(fd.get('quantity')) || 1 };
      var props = {};
      fd.forEach(function (value, key) {
        var m = key.match(/^properties\[(.+)\]$/);
        if (m && value) props[m[1]] = value;
      });
      if (Object.keys(props).length) item.properties = props;

      fetch(action + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        })
        .then(function () {
          return refresh();
        })
        .then(function () {
          open();
        })
        .catch(function () {
          /* Fallback: native form POST */
          HTMLFormElement.prototype.submit.call(form);
        });
    },
    true
  );

  /* ---------- Drawer events (delegated) ---------- */
  drawer.addEventListener('click', function (event) {
    var target = event.target.closest('[data-cart-close], [data-cart-checkout], [data-cart-coverage], [data-protection-toggle], [data-cart-dec], [data-cart-inc], [data-cart-remove], [data-cart-empty-cta]');
    if (!target) return;

    if (target.hasAttribute('data-cart-close')) {
      close();
    } else if (target.hasAttribute('data-cart-checkout')) {
      window.location.href = '/checkout';
    } else if (target.hasAttribute('data-cart-coverage')) {
      target.disabled = true;
      var remove = target.textContent.indexOf('without') !== -1;
      var req = remove ? removeProtection() : addProtection();
      req.finally(function () {
        target.disabled = false;
      });
    } else if (target.hasAttribute('data-protection-toggle')) {
      toggleProtection();
    } else if (target.hasAttribute('data-cart-dec') || target.hasAttribute('data-cart-inc')) {
      var key = target.getAttribute('data-cart-dec') || target.getAttribute('data-cart-inc');
      var qty = Number(target.getAttribute('data-qty')) || 0;
      qty += target.hasAttribute('data-cart-inc') ? 1 : -1;
      if (qty < 0) qty = 0;
      target.disabled = true;
      changeLine(key, qty).catch(function () {
        target.disabled = false;
      });
    } else if (target.hasAttribute('data-cart-remove')) {
      var removeKey = target.getAttribute('data-cart-remove');
      target.disabled = true;
      changeLine(removeKey, 0).catch(function () {
        target.disabled = false;
      });
    } else if (target.hasAttribute('data-cart-empty-cta')) {
      close();
    }
  });

  overlay.addEventListener('click', close);

  /* ---------- Header cart icon ---------- */
  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      open();
    });
  });

  /* ---------- Public API ---------- */
  window.CupidoCart = {
    open: open,
    close: close,
    refresh: refresh
  };
})();
